<template>
  <div class="container-fluid px-0">
    <!-- Hero Image -->
    <div class="hero-section">
      <img
        src="../../../../assets/boybanner.png"
        alt="Rural community child"
        class="img-fluid w-100"
        style="height: 400px; object-fit: cover"
      />
    </div>

    <!-- Campaign Content -->
    <div class="container mt-4">
      <div class="row justify-content-center">
        <div class="col-md-10 col-12 bg-gradient border mt-3 p-5">
          <div class="row justify-content-center">
            <div class="col-md-10">
              <!-- Campaign Title -->
              <div class="font-weight-600 s-32 mb-3 text-gradient">
                Rural area Community <br />
                Economic support
              </div>

              <!-- Organization Info -->
              <div class="d-flex align-items-center mb-4">
                <div class="mr-2">
                  <img
                    src="../../../../assets/churchplusblueLogo.png"
                    alt="Church Logo"
                    class="church-logo-mobile"
                  />
                </div>
                <span class="text-dak fw-400">Ebenezer Church</span>
              </div>

              <!-- Fundraising Progress -->
              <div class="mb-4">
                <div class="d-flex align-items-baseline mb-2">
                  <h2 class="text-dak fw-500 mb-0 me-2">NGN23,523,000</h2>
                  <h2 class="text-dak fw-400">/NGN700,000,000</h2>
                  <span class="ml-2 ms-2 fw-400">Raised</span>
                </div>

                <!-- Progress Bar -->
                <el-progress
                  :percentage="50.6"
                  :stroke-width="8"
                  color="#28a745"
                  class="mb-2"
                />

                <!-- Stats -->
                <div class="row">
                  <div class="col-6">
                    <span class="text-dak fw-300">8,500 People Donated</span>
                  </div>
                  <div class="col-6 text-end">
                    <span class="text-dak fw-300"
                      >Donation closes on 3rd August</span
                    >
                  </div>
                </div>
              </div>

              <div class="row">
                <div
                  style="background-color: #d7f8ff"
                  class="col-md-12 border-radius-60 px-3 py-3 d-flex justify-content-between"
                >
                  <el-button
                    link
                    class=""
                    :class="
                      activeTab === 'description'
                        ? 'text-dak font-weight-bold'
                        : 'text-dak fw-400'
                    "
                    @click="activeTab = 'description'"
                  >
                    <span class="s-15">Description</span>
                  </el-button>
                  <el-button
                    link
                    class=""
                    :class="
                      activeTab === 'howToHelp'
                        ? 'text-dak font-weight-bold'
                        : 'text-dak fw-400'
                    "
                    @click="activeTab = 'howToHelp'"
                  >
                    <span class="s-15">How to Help</span>
                  </el-button>
                  <el-button
                    link
                    class=""
                    :class="
                      activeTab === 'donorMessage'
                        ? 'text-dak font-weight-bold'
                        : 'text-dak fw-400'
                    "
                    @click="activeTab = 'donorMessage'"
                  >
                    <span class="s-15">Donor Message</span>
                  </el-button>
                </div>
              </div>

              <!-- Tabs -->

              <div
                v-if="activeTab === 'description'"
                class="text-dak fw-400 mt-3 lh-base"
              >
                <p class="mb-3">
                  The Kids' Health Care Mission is a dedicated campaign focused
                  on ensuring every child has access to the essential healthcare
                  they deserve. We believe that a healthy childhood is the
                  foundation for a brighter future, and this mission is
                  committed to making that vision a reality.
                </p>
                <p class="mb-3">
                  The Kids' Health Care Mission is a dedicated campaign focused
                  on ensuring every child has access to the essential healthcare
                  they deserve. We believe that a healthy childhood is the
                  foundation for a brighter future, and this mission is
                  committed to making that vision a reality.
                </p>
                <a
                  href="#"
                  style="font-style: italic"
                  class="text-dak fw-500 text-decoration-none"
                  >Read more</a
                >
              </div>
              <div
                v-if="activeTab === 'howToHelp'"
                class="text-dak mt-3 fw-400"
              >
                <p>
                  Learn how you can contribute to this important cause and make
                  a difference in children's lives.
                </p>
                <p class="mb-3">
                  The Kids' Health Care Mission is a dedicated campaign focused
                  on ensuring every child has access to the essential healthcare
                  they deserve. We believe that a healthy childhood is the
                  foundation for a brighter future, and this mission is
                  committed to making that vision a reality.
                </p>
                <a
                  href="#"
                  style="font-style: italic"
                  class="text-dak fw-500 text-decoration-none"
                  >Read more</a
                >
              </div>
              <div class="mt-5" v-if="activeTab === 'donorMessage'">
                <div class="form-label">Send a Message to Campaign Organizer</div>
                <el-input
                  v-model="donorMessage"
                  name="donorMessage"
                  id="donorMessage"
                  :rows="5"
                  type="textarea"
                />
              </div>

              <!-- Payment Method Selection -->
              <div class="row justify-content-center">
                <div class="mb-4 col-12 col-md-7 mt-5">
                  <h5 class="text-dak fw-500 mb-3">Choose a payment method</h5>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-12">
                        <div
                          class="payment-option text-dak mb-3"
                          :class="{
                            active: selectedPaymentOption === 'default',
                          }"
                          @click="selectDefaultPayment"
                        >
                          <el-radio
                            v-model="selectedPaymentOption"
                            label="default"
                          >
                            <span class="text-dak text-wrap">
                              ChurchPlus Payment Gateway</span
                            >
                          </el-radio>
                          <!-- <span class="mt-3">
                              </span
                            > -->
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div
                          class="payment-option text-dak"
                          :class="{
                            active: selectedPaymentOption === 'custom',
                          }"
                          @click="selectCustomPayment"
                        >
                          <el-radio
                            v-model="selectedPaymentOption"
                            label="custom"
                          >
                            <span class="text-dak text-wrap">
                              Or Link a Payment gateway</span
                            >
                          </el-radio>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mt-5 px-0">
                    <!-- Give Now Button -->

                    <el-button
                      round
                      :color="primarycolor"
                      size="large"
                      class="w-100 py-4 text-white fw-500"
                      @click="handleDonate"
                    >
                      Give now
                    </el-button>
                  </div>
                </div>
              </div>

              <!-- Footer -->
              <div class="col-md-12 px-0 mt-5">
                <div class="payment-methods mt-1">
                  <div class="payment-logos">
                    <img
                      src="../../../../assets/stripe.png"
                      alt="Paystack"
                      class="payment-logo"
                    />
                    <img
                      src="../../../../assets/visasmall.png"
                      alt="Mastercard"
                      style="height: 13px !important"
                      class="payment-logo"
                    />
                    <img
                      src="../../../../assets/3MasterCard500.png"
                      alt="Mastercard"
                      class="payment-logo"
                    />

                    <img
                      src="../../../../assets/4PaystackLogo.png"
                      alt="Visa"
                      class="payment-logo"
                    />
                    <img
                      src="../../../../assets/flutterwavelogo.png"
                      alt="Paystack"
                      class="payment-logo"
                      style="height: 40px !important"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-12 text-center">
                <p class="text-muted small fw-400 mb-3">
                  <i class="fas fa-shield-alt me-1"></i>
                  Payments are secured by World Class Payment Encryption SYSTEM
                </p>
              </div>
              <div class="col-12 mt-4">
                <div class="footer-section">
                  <!-- <div class="footer-divider"></div> -->
                  <p
                    class="powered-by d-flex flex-column align-items-center justify-content-center"
                  >
                    <span class="fw-400">Powered by</span>
                    <img
                      src="../../../../assets/churchplusblueLogo.png"
                      alt="ChurchPlus"
                      class="logo"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";

// Reactive data
const activeTab = ref("description");
const paymentMethod = ref("churchplus");
const selectedPaymentOption = ref("");
const primarycolor = inject("primarycolor");
const donorMessage = ref("");

// Methods
const handleDonate = () => {
  console.log(
    "[v0] Donate button clicked with payment method:",
    paymentMethod.value
  );
  // Handle donation logic here
};
</script>

<style scoped>
.logo {
  height: 40px;
  width: auto;
}
.payment-methods {
  text-align: center;
  /* margin-top: 2rem; */
}

.payment-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  /* margin-bottom: rem; */
}
.church-logo-mobile {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  object-fit: cover;
}
.payment-logo {
  height: 18px;
  object-fit: contain;
}
.bg-gradient {
  background: linear-gradient(240deg, #ffffff 0%, #f1fbff 100%);
  padding: 20px;
  border-radius: 12px;
}
.text-gradient {
  background: linear-gradient(270deg, #0e59e4 0%, #043591 55.29%) !important;
  background-clip: text !important;
  color: transparent !important;
}
.payment-option {
  background: #d9ebef;
  border-radius: 11px;
  padding: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-option:hover {
  background: #d6ebfa;
}

.payment-option.active {
  background: #d9ebef;
}
.hero-section {
  position: relative;
  overflow: hidden;
}

.lh-base {
  line-height: 1.6;
}

/* Custom Element Plus overrides */
:deep(.el-tabs__header) {
  margin-bottom: 20px;
}

:deep(.el-tabs__nav-wrap::after) {
  background-color: #e9ecef;
}

:deep(.el-tabs__active-bar) {
  background-color: #1976d2;
}

:deep(.el-tabs__item.is-active) {
  color: #1976d2;
  font-weight: 500;
}

:deep(.el-tabs__item) {
  color: #6c757d;
  font-weight: 400;
}
.form-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #000000;
  /* margin-bottom: 0.5rem; */
  display: block;
}

:deep(.el-radio) {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 0;
}

:deep(.el-radio__input) {
  margin-right: 12px;
}

:deep(.el-radio__label) {
  flex: 1;
  padding-left: 0;
}

:deep(.el-progress-bar__outer) {
  border-radius: 4px;
}

:deep(.el-progress-bar__inner) {
  border-radius: 4px;
}
</style>
